import { AnimatePresence } from "motion/react";
import { FC, useState } from "react";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { IReportTemplateItemTranslated } from "@ryde/shared";

import { ReportStartPageItem } from "./report-start-page.item";
import {
  ReportStartPageGroupContainerStyled,
  ReportStartPageGroupHeaderStyled,
} from "./report-start-page.styled";

interface IReportStartPageGroupHeader {
  groupTitle: string;
  collapsed?: boolean;
  toggleCollapse: () => void;
}

const ReportStartPageGroupHeader: FC<IReportStartPageGroupHeader> = ({
  groupTitle,
  collapsed,
  toggleCollapse,
}) => {
  return (
    <ReportStartPageGroupHeaderStyled onClick={() => toggleCollapse()}>
      {!collapsed && (
        <SVG_MUI.ChevronDownSVG
          className="collapse_toggle"
          title="Collapse grouping"
        />
      )}
      {!!collapsed && (
        <SVG_MUI.ChevronUpSVG
          className="collapse_toggle"
          title="Collapse grouping"
        />
      )}
      {groupTitle}
    </ReportStartPageGroupHeaderStyled>
  );
};

export const ReportStartPageGroup: FC<IReportTemplateItemTranslated> = ({
  titleTranslated,
  items,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = useEvent(() => {
    setCollapsed(!collapsed);
  });
  return (
    <ReportStartPageGroupContainerStyled>
      <ReportStartPageGroupHeader
        toggleCollapse={toggleCollapse}
        collapsed={collapsed}
        groupTitle={titleTranslated}
      />
      <AnimatePresence>
        {!collapsed &&
          items.map(x => <ReportStartPageItem key={x.id} {...x} />)}
      </AnimatePresence>
    </ReportStartPageGroupContainerStyled>
  );
};
